import { cart } from 'src/common/assets/i18n-assets/en/cart';
import { common } from 'src/common/assets/i18n-assets/en/common';
import { habaAddress } from 'src/common/assets/i18n-assets/en/habaAddress';
import { habaCart } from 'src/common/assets/i18n-assets/en/habaCart';
import { habaCatalogForm } from 'src/common/assets/i18n-assets/en/habaCatalogForm';
import { habaContactForm } from 'src/common/assets/i18n-assets/en/habaContactForm';
import { habaCheckout } from 'src/common/assets/i18n-assets/en/habaCheckout';
import { habaCommon } from 'src/common/assets/i18n-assets/en/habaCommon';
import { habaCountries } from 'src/common/assets/i18n-assets/en/habaCountries';
import { habaMyAccountNavigation } from 'src/common/assets/i18n-assets/en/habaMyAccountNavigation';
import { habaProduct } from 'src/common/assets/i18n-assets/en/habaProduct';
import { habaUser } from 'src/common/assets/i18n-assets/en/habaUser';
import { habaWishlist } from 'src/common/assets/i18n-assets/en/habaWishlist';
import { userProfile } from 'src/common/assets/i18n-assets/en/userProfile';
import { product } from 'src/common/assets/i18n-assets/en/product';
import { newsletter } from 'src/common/assets/i18n-assets/en/newsletter';
import { seo } from 'src/common/assets/i18n-assets/en/seo';
import { cookiePage } from 'src/common/assets/i18n-assets/en/cookiePage';
import { returns } from 'src/common/assets/i18n-assets/en/returns';
import { habaAltText } from '../../../../common/assets/i18n-assets/en/alt-text';

export const enTranslationsHaba = {
  cart,
  common,
  cookiePage,
  habaAddress,
  habaCart,
  habaCatalogForm,
  habaContactForm,
  habaCheckout,
  habaCommon,
  habaCountries,
  habaMyAccountNavigation,
  habaProduct,
  habaUser,
  habaWishlist,
  userProfile,
  product,
  newsletter,
  seo,
  returns,
  habaAltText,
};
